import { render, staticRenderFns } from "./Approval.vue?vue&type=template&id=c0399504&scoped=true"
import script from "./Approval.vue?vue&type=script&lang=ts"
export * from "./Approval.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0399504",
  null
  
)

export default component.exports